var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFunnelPlotOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1894 3.00781H2.81049C2.33197 3.00781 2.03314 3.5293 2.27338 3.94531L6.81635 11.8633V16.3672C6.81635 16.7129 7.09369 16.9922 7.43744 16.9922H12.5624C12.9062 16.9922 13.1835 16.7129 13.1835 16.3672V11.8633L17.7285 3.94531C17.9667 3.5293 17.6679 3.00781 17.1894 3.00781ZM11.7851 15.5859H8.21478V12.6953H11.7871V15.5859H11.7851ZM11.9726 11.1602L11.8085 11.4453H8.18939L8.02533 11.1602L6.53119 8.55469H13.4687L11.9726 11.1602ZM14.1855 7.30469H5.81439L4.15424 4.41406H15.8456L14.1855 7.30469Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnelPlotOutlined);
export default __webpack_public_path__ + "static/media/funnel_plot_outlined.3378b7925823461fd1061660acd9cf51.svg";
export { ForwardRef as ReactComponent };